<template>
  <div class="settings-container">
    <div class="file-upload">
      <button class="select-file-button" @click="openSelector">
        <font-awesome-icon icon="fa-solid fa-file-circle-plus" />
      </button>
      <input type="file" id="select-file" accept=".tsv" ref="load_button" @change="readFile" value="CHOOSE FILE"
        class="select-file" />
    </div>
    <div v-if="fileName">
      File Selected:
      <span class="file-name">{{ fileName }}</span>
    </div>
    <div v-else :class="{ 'tsv-file-instruction': leagueMatch }">
      {{ `Please select a .tsv file` }}
    </div>
    <div class="slider-container" v-if="false">
      <span :class="{ 'switch-label': true, 'label-fade': gameType === 'mimir' }">Stakes</span>
      <label class="switch">
        <input type="checkbox" :checked="gameType === 'mimir'" @change="setGameTypeHandler" />
        <span class="mimir-stakes-slider round"></span>
      </label>
      <span :class="{ 'switch-label': true, 'label-fade': gameType === 'stakes' }">Mimir</span>
      <div v-if="gameType === 'stakes'">
        Stakes functionality is planned to soon be disabled. If you are using the Stakes format and would like it to
        remain, please get in touch.
      </div>
    </div>
    <table class="settings-table">
      <tr>
        <td class="table-left">
          <label for="">Name of League: </label>
        </td>
        <td class="table-right">
          <input type="text" name="league-name" :value="leagueName" maxlength="40" disabled />
        </td>
        <td class="table-left">
          <label for="">Number of Rounds: </label>
        </td>
        <td class="table-right">
          <input type="number" name="number-rounds" :value="numRounds || ''" maxlength="40" disabled />
        </td>
      </tr>
      <tr>
        <td class="table-left">
          <label for="">Season: </label>
        </td>
        <td class="table-right">
          <input type="text" name="league-season" :value="leagueSeason" maxlength="40" disabled />
        </td>
        <td class="table-left">
          <label for="">Number of Players: </label>
        </td>
        <td class="table-right">
          <input type="number" name="number-players" :value="numPlayers || ''" maxlength="40" disabled />
        </td>
      </tr>
      <tr>
        <td class="table-left">
          <label for="">Game Week: </label>
        </td>
        <td class="table-right">
          <input type="text" name="game-week" :value="gameWeek" maxlength="40" disabled />
        </td>
        <td class="table-left">
          <label for="">Directs per Player: </label>
        </td>
        <td class="table-right">
          <input type="number" name="number-directs" :value="numDirects || ''" maxlength="40" disabled />
        </td>
      </tr>
      <tr>
        <td class="table-left">
          <label for="">Match #: </label>
        </td>
        <td class="table-right">
          <input type="text" name="match-number" :value="matchNumber" maxlength="40" disabled />
        </td>
        <td class="table-left">
          <label for="">Time on Direct: </label>
        </td>
        <td class="table-right">
          <input type="number" class="timer-controls" v-model="timer.directTime" step="5" max="120" min="10" />
        </td>
      </tr>
      <tr>
        <td class="table-left">
          <label for="">Reader Name: </label>
        </td>
        <td class="table-right">
          <input type="text" name="reader-name" @change="setReaderName($event.target.value)" :value="readerName"
            maxlength="25" />
        </td>
        <td class="table-left">
          <label for="">Time on Pass: </label>
        </td>
        <td class="table-right">
          <input type="number" class="timer-controls" v-model="timer.passTime" max="60" min="0" step="5" />
        </td>
      </tr>

      <tr>
        <td class="table-left">
          <label for="time-stamp">
            Start Date & Time
          </label>
        </td>

        <td class="table-right">
          <input type="text" :value="getCurrentTime" disabled>
        </td>

        <td class="table-left">
          <label for="">Time on Empty: </label>
        </td>
        <td class="table-right">
          <input type="number" class="timer-controls" v-model="timer.passOnEmptyTime" :max="timer.directTime" min="0"
            step="5" />
        </td>
      </tr>
      <tr v-if="!leagueMatch">
        <td class="table-left">
          <label for="">Self Read: </label>
        </td>
        <td class="table-right">
          <span :class="{ 'label-fade': getSelfReadSwitch }"></span>
          <label class="switch">
            <input type="checkbox" name="self-read" v-model="getSelfReadSwitch" />
            <span class="self-read-slider round"></span>
          </label>
          <span :class="{ 'label-fade': !getSelfReadSwitch }"></span>
          <font-awesome-icon title="Use the Eye icon button to toggle peek mode for the answer"
            icon="fa-regular fa-circle-question" class="tooltip" />
        </td>
        <td class="table-left">
          <label for="">Free Direct: </label>
        </td>
        <td class="table-right">
          <span :class="{ 'label-fade': getFreeDirectSwitch }"></span>
          <label class="switch">
            <input type="checkbox" name="free-direct" v-model="getFreeDirectSwitch" />
            <span class="free-direct-slider round"></span>
          </label>
          <span :class="{ 'label-fade': !getFreeDirectSwitch }"></span>
          <font-awesome-icon
            title="If OFF then attempts on directs also count toward BAs, the only true and correct way to play a Mimir despite everything you have been told all along!"
            icon="fa-regular fa-circle-question" class="tooltip" />
        </td>
      </tr>
    </table>

    <wait-spinner v-if="fileName && !objectId" />
    <button class="start-resume-button" @click="startGame" v-else :disabled="!fileName || !objectId">
      <font-awesome-icon icon="fa-solid fa-play" />
    </button>
    <fvl-dialog-box v-bind="{
      showModal: showConfirmation,
      message,
    }" @ok="okHandler()" @cancel="cancelHandler()" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { csv } from "csvtojson";
import { v4 as uuidv4 } from "uuid";
import WaitSpinner from "./WaitSpinner.vue";
import fvlDialogBox from "./library/fvlDialogBox.vue";

export default {
  name: "SettingsPage",
  data() {
    return {
      players: null,
      rounds: null,
      directs: null,
      csv,
      inputText: "",
      showConfirmation: false,
      // selfRead: false,
      message:
        "Do you want to start a new game? If not please use the game reload button from the game view.",
    };
  },
  components: {
    WaitSpinner,
    fvlDialogBox,
  },
  computed: {
    ...mapState([
      "timer",
      "numDirects",
      "numPlayers",
      "numRounds",
      "leagueName",
      "leagueSeason",
      "gameWeek",
      "matchNumber",
      "fileName",
      "gameId",
      "objectId",
      "gameType",
      "readerName",
      "currentQuestionNo",
      "leagueMatch",
      "questionDisplayMode",
    ]),
    ...mapGetters(["getSelfReadSwitch"]),
    getSelfReadSwitch: {
      get() {
        return this.$store.state.selfReadSwitch;
      },
      set(_value) {
        this.$store.dispatch("toggleSelfReadValue");
      }
    },
    getFreeDirectSwitch: {
      get() {
        return this.$store.state.freeDirect;
      },
      set(_value) {
        this.$store.dispatch("toggleFreeDirect")
      }
    },
    getCurrentTime() {
      const now = new Date();

      // Extract and format each part of the date and time
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = now.getFullYear();

      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');

      // Format as dd/mm/yyyy hh:mm:ss
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
  },

  mounted() {
    const queryParams = this.$route.query;

    if (Object.keys(queryParams).length > 0) {
      this.setLeagueParams(queryParams)
    }
  },

  methods: {
    ...mapActions([
      "setupInitGame",
      "setFileName",
      "setGameId",
      "setGameType",
      "resetTimer",
      "restartGame",
      "setReaderName",
      "setInstructions",
      "setLeagueParams",
      "setLog",
      "switchQuestionMode",
    ]),
    setGameTypeHandler(e) {
      const gameType = e.target.checked ? "mimir" : "stakes";
      this.setGameType(gameType);

      this.timer.passTime = gameType === "mimir" ? 5 : 15;

      this.restartGame();
    },
    okHandler() {
      console.log("ok");
      this.showConfirmation = false;
    },
    startGame() {
      this.resetTimer();
      if (this.questionDisplayMode === 'Start' && this.leagueMatch) {
        this.switchQuestionMode("Answer")
      }
      this.$router.push(`/game/${this.gameType}/${this.gameId}`);
    },
    openSelector() {
      this.$refs.load_button.click();
    },
    setDirects(e) {
      this.directs = parseInt(e.target.value);
    },
    setPlayers(e) {
      this.players = parseInt(e.target.value);
    },
    setRounds(e) {
      this.rounds = parseInt(e.target.value);
    },
    // checkConfirmation(e) {
    //   if (this.gameId) {
    //     this.showConfirmation = true;
    //     return;
    //   } else {
    //     this.readFile(e);
    //   }
    // },
    // readFile(e) {
    //   this.setFileName(e.target.files[0].name);
    //   e.target.files[0].text().then((t) => {
    //     this.inputText = t;
    //   });
    //   setTimeout(() => {
    //     this.convertDataStart();
    //   }, 100);
    // },
    readFile(e) {
      let resp = true;
      if (this.currentQuestionNo > 0) {
        resp = confirm(this.message);
      }
      if (resp) {
        this.setFileName(e.target.files[0].name);
        e.target.files[0].text().then((t) => {
          this.inputText = t;
          this.setLog(t);
        });
        setTimeout(() => {
          this.convertDataStart();
        }, 100);
      }
    },
    convertDataStart() {
      let data = this.inputText.split("\n");
      let instructions = [];
      const headers = data[0].split("\t").map((x) => x.trim());

      data.slice(1).forEach((x) => {
        const row = x.split("\t");
        if (row[0].toLowerCase() === "instructions" && row[1].trim().length > 0) {
          instructions.push(row[1]);
        }
      });

      data = data.slice(1).map((x) => {
        const row = x.split("\t");

        const result = headers.reduce((prev, curr, index) => {
          if (row.length === 4) {
            console.log(row)
          }
          if (curr && row.length >= headers.length) {
            prev = { ...prev, [curr]: row[index] };
            if (curr === "roundNo") {
              const search = row[index].match(/Round ([0-9]+) Player ([0-9]+)/);
              if (search) {
                prev.round = parseInt(search[1]);
                prev.player = parseInt(search[2]);
              }
            }
            if (curr === "questionNo") {
              const search = row[index].match(/Question ([0-9]+)/);
              if (search) {
                prev.direct = parseInt(search[1]);
              }
            }
            if (curr === "imageUrl") {
              if (!row[index].match(/jpg|jpeg|png|static|wiki|gif|svg/i)) {
                prev.imageUrl = "";
              }
            }
          }
          return prev;
        }, {});
        // console.log(x.split("\t"));
        return result;
      });

      const gameId = uuidv4();
      this.setGameId(gameId);

      const questions = data.filter((x) => x.round && x.player && x.direct);

      if (questions.length > 0) {
        this.setupInitGame(questions);
        this.setInstructions(instructions);
      }

      this.$toast.open({
        message: "Questions loaded",
        duration: 3000,
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 36px;
}

.file-upload {
  width: 30%;
  display: flex;
  margin: 15px auto;
  justify-content: space-around;
}

.tsv-file-instruction {
  font-size: 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.settings-table {
  margin: 20px auto;
  text-align: left;
  font-size: 24px;
}

td {
  padding: 15px;
}

input,
select,
option {
  font-size: 20px;
  padding: 5px;
  font-family: Nunito;
}

input[type="number"] {
  width: 50px;
}

input[type="text"] {
  width: 350px;
}


input[type="button"],
input::file-selector-button {
  background-color: rgb(105, 144, 175);
  color: rgb(255, 255, 255);
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

button:disabled {
  background-color: rgb(212, 212, 212);
  color: rgb(255, 255, 255);
  border: none;
  border-radius: 10px;
  cursor: not-allowed;
}

.tooltip {
  color: grey;
  margin-left: 10px;
}

#select-file {
  display: none;
}

.file-name {
  font-weight: bold;
  font-family: monospace;
  font-size: 18px;
}

.select-file-button,
.start-resume-button {
  font-size: 32px;
  padding: 20px 30px;
  margin: 10px auto;
  background-color: rgb(33, 100, 175);
  color: rgb(255, 255, 255);
  border: none;
  border-radius: 10px;
  cursor: pointer;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.round {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.mimir-stakes-slider {
  background-color: #df8014;
}

.self-read-slider,
.free-direct-slider {
  background-color: lightgray;
}

.round:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked+.round {
  background-color: rgb(33, 100, 175);
}

input:focus+.round {
  box-shadow: 0 0 1px rgb(33, 100, 175);
}

input:checked+.round:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.round {
  border-radius: 34px;
}

.round:before {
  border-radius: 50%;
}

.slider-container {
  margin: 20px auto;
  line-height: 40px;
}

.switch-label {
  font-size: 24px;
  margin: auto 20px;
  font-weight: bolder;
}

.label-fade {
  opacity: 0.4;
  font-weight: normal;
}

/* .table-left {
  text-align: right;
} */

.dot-spinner {
  margin: 20px auto;
}
</style>